module.exports = __webpack_public_path__ + "img/preview-selected.e6887fea.svg";